"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "What does AeronPay HRMS do?",
    a: "AeronPay is a complete HR platform that brings your employee, payroll, attendance, and performance data together in one place — giving you the accuracy and coordination you need without stitching together five different tools.",
  },
  {
    q: "Does AeronPay handle payroll?",
    a: "Yes — configurable salary structures, statutory compliance, and automatic payslip generation are built in, not bolted on.",
  },
  {
    q: "How much does AeronPay cost?",
    a: "Pricing scales with headcount and modules used. See our Pricing page for current tiers, or book a demo for a tailored quote.",
  },
  {
    q: "Is my data secure?",
    a: "All data is encrypted in transit and at rest, with role-based access enforced on every request — no user ever sees data their role doesn't permit.",
  },
  {
    q: "Can I migrate from our current HR tool?",
    a: "Yes — our onboarding team handles data migration from most common HRMS and spreadsheet-based systems as part of setup.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 md:py-32 bg-muted/30 border-y border-border/60">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-foreground text-center mb-14">
          Frequently asked questions
        </h2>

        <div className="border-t border-border">
          {FAQS.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={faq.q} className="border-b border-border">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between py-6 text-left"
                >
                  <span className="font-display text-lg font-semibold text-foreground pr-6">
                    {faq.q}
                  </span>
                  <ChevronDown
                    size={18}
                    className={`shrink-0 text-muted-foreground transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 text-sm text-muted-foreground leading-relaxed max-w-xl">
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
